/*
 * Drag-to-slide for the product gallery.
 *
 * The media list is an overflow-x scroll-snap track, which touch and
 * trackpads scroll natively — but a mouse cannot swipe, so on desktop the
 * main frame was only reachable via the arrows or the thumbnail rail.
 * This adds pointer dragging for mouse and pen, and leaves touch alone so
 * native momentum scrolling is not fought.
 */
(() => {
  const DRAG_CLASS = 'is-dragging';
  const CLICK_THRESHOLD = 5; // px of travel before a drag suppresses the click

  function init(track) {
    if (track.dataset.dragReady) return;
    track.dataset.dragReady = 'true';

    let dragging = false;
    let startX = 0;
    let startScroll = 0;
    let travelled = 0;

    track.addEventListener('pointerdown', (event) => {
      // Touch already scrolls natively; only take over for mouse and pen.
      if (event.pointerType === 'touch' || event.button !== 0) return;

      dragging = true;
      travelled = 0;
      startX = event.clientX;
      startScroll = track.scrollLeft;
      // Snapping fights a drag in progress; it is restored on release.
      track.classList.add(DRAG_CLASS);
    });

    track.addEventListener('pointermove', (event) => {
      if (!dragging) return;

      const delta = event.clientX - startX;
      travelled = Math.abs(delta);
      track.scrollLeft = startScroll - delta;
    });

    const end = () => {
      if (!dragging) return;
      dragging = false;
      track.classList.remove(DRAG_CLASS);
    };

    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('pointerleave', end);

    // Images are natively draggable, which would hijack the gesture.
    track.addEventListener('dragstart', (event) => event.preventDefault());

    // A drag ends in a click. Swallow it during capture so releasing the
    // mouse over the photo does not also open the zoom lightbox.
    track.addEventListener(
      'click',
      (event) => {
        if (travelled > CLICK_THRESHOLD) {
          event.preventDefault();
          event.stopPropagation();
        }
        travelled = 0;
      },
      true
    );
  }

  function initAll(root = document) {
    root.querySelectorAll('.product__media-list.slider--tablet-up').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  // Section re-renders in the theme editor, and variant changes that swap
  // the gallery, both need the new track wired up.
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
